export default {"src":"/_next/static/media/crossSmallRed_24.0a83197b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};